import * as THREE from 'three';
import { yawOf } from '../core/directions.js';
import { CONFIG } from '../config.js';

const HW = CONFIG.path.width / 2;
const _pos = new THREE.Vector3();

/**
 * Arco dorado con el letrero «RÉCORD» sobre el camino, a la distancia de tu mejor partida.
 * Se coloca en cuanto ese punto del camino está generado. Solo para el navegador (usa canvas).
 */
export class RecordMarker {
  constructor(scene) {
    const gold = new THREE.MeshLambertMaterial({ color: 0xffd23a, emissive: 0x8a5a00, flatShading: true });
    this.group = new THREE.Group();
    this.group.name = 'RecordMarker';
    for (const side of [-1, 1]) {
      const post = new THREE.Mesh(new THREE.CylinderGeometry(0.09, 0.12, 3.4, 6), gold);
      post.position.set(side * (HW + 0.25), 1.7, 0);
      this.group.add(post);
    }
    const canvas = document.createElement('canvas');
    canvas.width = 512;
    canvas.height = 96;
    const g = canvas.getContext('2d');
    g.fillStyle = 'rgba(20,14,0,0.75)';
    g.fillRect(0, 0, 512, 96);
    g.strokeStyle = '#ffd23a';
    g.lineWidth = 8;
    g.strokeRect(4, 4, 504, 88);
    g.fillStyle = '#ffe680';
    g.font = 'bold 60px system-ui, sans-serif';
    g.textAlign = 'center';
    g.textBaseline = 'middle';
    g.fillText('RÉCORD', 256, 52);
    const tex = new THREE.CanvasTexture(canvas);
    tex.colorSpace = THREE.SRGBColorSpace;
    const banner = new THREE.Mesh(
      new THREE.PlaneGeometry(HW * 2 + 0.5, 0.75),
      new THREE.MeshBasicMaterial({ map: tex, side: THREE.DoubleSide, transparent: true }),
    );
    banner.position.y = 3.1;
    this.group.add(banner);
    this.group.visible = false;
    scene.add(this.group);
    this.target = 0;
  }

  /** Nueva partida: el arco marcará esta distancia (0 = sin récord que mostrar). */
  reset(distance) {
    this.target = distance;
    this.passed = distance <= 0;
    this.group.visible = false;
  }

  /** Coloca el arco y devuelve true en el instante en que el jugador lo cruza. */
  update(player, path, time) {
    if (this.passed) return false;
    if (player.distance >= this.target) {
      this.passed = true;
      this.group.visible = false;
      return true;
    }
    // La distancia recorrida y la posición en el tramo difieren un poco tras cada curva.
    const drift = player.distance - (player.segment.startDist + player.s);
    for (let seg = player.segment; seg; seg = seg.next) {
      const s = this.target - drift - seg.startDist;
      if (s < seg.length) {
        path.worldPoint(seg, Math.max(0, s), 0, _pos);
        this.group.position.copy(_pos);
        this.group.rotation.y = yawOf(seg.dirIndex);
        this.group.visible = true;
        this.group.children[2].position.y = 3.1 + Math.sin(time * 2) * 0.06;
        return false;
      }
    }
    this.group.visible = false;
    return false;
  }
}
